export default {
  step: state => state.step,
  addresses: state => state.addresses,
  originalAddresses: state => state.originalAddresses
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/usps/getters.js